import Title from "../shared/components/Title";
import { useDropzone } from "react-dropzone";
import UploadedItemCard from "../features/rate-card-converter/components/UploadedItemCard";
import { colors } from "../global";
import OverlayLoading from "../shared/components/OverlayLoading";
import DropzoneComponent from "../shared/components/DropzoneComponent";
import { useRateCardConverter } from "../features/rate-card-converter/hooks/useRateCardConverter";

const RateCardConverter = () => {
  const { files, isSubmitting, onDrop, handleSubmit, handleMetadataUpdate, removeFile, clearFiles } =
    useRateCardConverter();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".csv",
    multiple: true,
  });

  return (
    <>
      {isSubmitting && (
        <OverlayLoading
          isVisible={isSubmitting}
          message="Processing your request..."
          icon="truck"
        />
      )}
      <div className="space-y-6 p-6 pb-4">
        <Title title={"Rate Card Converter"} />

        {/* Dropzone */}
        <DropzoneComponent
          getInputProps={getInputProps}
          getRootProps={getRootProps}
          isDragActive={isDragActive}
          fileTypes="CSV/XLSX"
        />

        {/* File List */}
        {files.length > 0 && (
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h3
                className="text-lg font-semibold"
                style={{ color: colors.primary }}
              >
                Files ({files.length})
              </h3>
              {files.length > 0 && (
                <button
                  onClick={clearFiles}
                  className="text-sm py-1 px-3 rounded hover:cursor-pointer"
                  style={{ color: colors.accent }}
                >
                  Clear All
                </button>
              )}
            </div>

            <div className="space-y-3">
              {files.map((file) => (
                <UploadedItemCard
                  key={file.renamedFile.name}
                  file={file.renamedFile}
                  sheetList={file.sheetList}
                  onDelete={removeFile}
                  onUpdateMetadata={handleMetadataUpdate}
                />
              ))}
            </div>
          </div>
        )}

        {/* Submit Button */}
        {files.length > 0 && (
          <div className="flex justify-end pt-4">
            <button
              onClick={handleSubmit}
              disabled={isSubmitting || files.length === 0}
              className="py-2 px-6 rounded-md font-medium shadow-sm transition-all flex items-center justify-center hover:cursor-pointer"
              style={{
                backgroundColor: isSubmitting ? "#ccc" : colors.accent,
                color: colors.white,
                opacity: isSubmitting || files.length === 0 ? 0.7 : 1,
              }}
            >
              {isSubmitting ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </>
              ) : (
                "Convert Files"
              )}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default RateCardConverter;
